import { Pipe, PipeTransform } from '@angular/core';
import divide from 'lodash-es/divide';

@Pipe({ name: 'kb', pure: true })
export class GetKilobytePipe implements PipeTransform {
  transform = (value: number): number => divide(value, 1000);
}
